import { useEffect, useRef, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useAuth } from "../../../context_providers/auth/authProvider";
import LoadingWidget from "../../../context_providers/modal/loader";
import { LogoutApi } from "../../../service/repos/auth_repo";
import {
  ToastType,
  useToast,
} from "../../../context_providers/toast/toast_ctx";

const LogoutPage = () => {
  const { setUser } = useAuth();
  const history = useHistory();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const hasLoggedOut = useRef(false);
  const { showToast } = useToast();

  const doLogout = async () => {
    try {
      const res = await LogoutApi();
      if (res.success) {
        setUser(undefined);

        const preserveKey = "NEVER_INSTALL";
        Object.keys(localStorage).forEach((key) => {
          if (key !== preserveKey) {
            localStorage.removeItem(key);
          }
        });

        showToast({ type: ToastType.success, text: res.message });
      } else {
        showToast({ type: ToastType.error, text: res.error });
      }
      if (location.pathname !== "/login") {
        history.replace("/login");
      }
    } catch (err) {
      console.error("Logout error:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Prevent multiple runs
    // if (hasLoggedOut.current) return;
    // hasLoggedOut.current = true;

    doLogout();
    return () => {
      hasLoggedOut.current = false;
    };
  }, [location.pathname]);

  return <>{loading && <LoadingWidget />}</>;
};

export default LogoutPage;
